import { STATUS_STYLES, PRIORITY_STYLES } from "@/constants/options";

export const StatusPill = ({ value, testid }) => {
  if (!value) return <span className="text-neutral-400">—</span>;
  const cls = STATUS_STYLES[value] || "bg-neutral-200 text-neutral-700";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${cls}`}
    >
      {value}
    </span>
  );
};

export const PriorityPill = ({ value }) => {
  if (!value) return <span className="text-neutral-400">—</span>;
  const cls = PRIORITY_STYLES[value] || "bg-neutral-100 text-neutral-600 border-neutral-300";
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold ${cls}`}>
      {value}
    </span>
  );
};
